export const timeUnits = [
    {
        block: null,
        timeSlots: [
            {
                from: "08:30",
                to: "09:10"
            },
            {
                from: "09:15",
                to: "09:55"
            },
            {
                from: "10:05",
                to: "10:45"
            },
            {
                from: "10:55",
                to: "11:35"
            }
        ]
    },
    {
        block: "Lunsj",
        timeSlots: [
            {
                from: "12:00",
                to: "12:40"
            },
            {
                from: "12:50",
                to: "13:30"
            },
            {
                from: "13:40",
                to: "14:20"
            },
            {
                from: "14:30",
                to: "15:10"
            },
        ]
    },
    {
        block: "Ettermiddag",
        timeSlots: [
            {
                from: "15:20",
                to: "16:00"
            },
            {
                from: "16:05",
                to: "16:45"
            },
            {
                from: "16:55",
                to: "17:35"
            },
            {
                from: "17:45",
                to: "18:25"
            },
        ]
    },
    {
        block: "Kveld",
        timeSlots: [
            {
                from: "18:40",
                to: "19:20"
            },
            {
                from: "19:25",
                to: "20:05"
            },
            {
                from: "20:10",
                to: "20:50"
            },
        ]
    },
]

export const timeBlocks = [
    {
        from: "08:30",
        to: "09:10"
    },
    {
        from: "09:15",
        to: "09:55"
    },
    {
        from: "10:05",
        to: "10:45"
    },
    {
        from: "10:55",
        to: "11:35"
    },
    {
        from: "12:00",
        to: "12:40"
    },
    {
        from: "12:50",
        to: "13:30"
    },
    {
        from: "13:40",
        to: "14:20"
    },
    {
        from: "14:30",
        to: "15:10"
    },
    {
        from: "15:20",
        to: "16:00"
    },
    {
        from: "16:05",
        to: "16:45"
    },
    {
        from: "16:55",
        to: "17:35"
    },
    {
        from: "17:45",
        to: "18:25"
    },
    {
        from: "18:40",
        to: "19:20"
    },
    {
        from: "19:25",
        to: "20:05"
    },
    {
        from: "20:10",
        to: "20:50"
    },
]

export const days = [
    "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag"
]



export default timeUnits;


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/timetable/timeUnits.js